import * as React from "react"

import { Link } from "gatsby"
import Home from "../components/home"
import Seo from "../components/seo"

const MobilezposPage = () => (
  <Home>
      <Seo title="video demo mobile point of sale application cashier" />
    <h1><strong><a title="video demo mobile point of sale application cashier" href="/mobilezpos">MOBILEPOS</a></strong></h1>
<div className="embed-responsive embed-responsive-4by3">
<iframe title="video demo mobile point of sale application cashier" width="560" height="315" 
src="https://www.youtube.com/embed/DWFDeQuU2E4" 
frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</div>
<br/>
<Link to="/zpos" className="button button-outline">Back ZPOS Apps</Link>
  </Home>
)

export default MobilezposPage